import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.hanscribe.final.chart');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { hanscribeStatusBadgeClass } from "src/libs/portal/hanscribe/hanscribe";

type WorkspaceMap = Record<string, any>;

@Component({
    selector: 'wiz-portal-hanscribe-final-chart',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.hanscribe.final.chart/view.scss */
:host {
  display: block;
  height: 100%;
}

.final-chart {
  display: flex;
  height: 100%;
  min-height: 100%;
  flex-direction: column;
  overflow: hidden;
  background: var(--hs-surface-base, #ffffff);
  color: var(--hs-text-strong, #111827);
}

.final-chart-header {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid var(--hs-border-subtle, #dde3ea);
  padding: 12px 14px;
}

.final-title-block {
  min-width: 0;
}

.final-title-row,
.final-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.final-title-row h2 {
  margin: 0;
  color: var(--hs-text-strong, #111827);
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
}

.final-title-block p {
  overflow: hidden;
  margin: 4px 0 0;
  color: var(--hs-text-muted, #64748b);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-badge {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid transparent;
  border-radius: var(--hs-radius-md, 6px);
  padding: 0 8px;
  font-size: 11px;
  font-weight: 700;
  line-height: 16px;
  white-space: nowrap;
}

.status-badge::before {
  content: "";
  width: 6px;
  height: 6px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: currentColor;
}

.status-badge--neutral,
.status-badge--muted {
  border-color: var(--hs-color-neutral-200, #dde3ea);
  background: var(--hs-color-neutral-100, #eef2f6);
  color: var(--hs-color-neutral-700, #334155);
}

.status-badge--primary {
  border-color: var(--hs-color-primary-100, #cdeee8);
  background: var(--hs-color-primary-50, #e8f7f4);
  color: var(--hs-color-primary-700, #0f766e);
}

.status-badge--info {
  border-color: var(--hs-color-info-100, #dbeafe);
  background: var(--hs-color-info-50, #eff6ff);
  color: var(--hs-color-info-700, #1d4ed8);
}

.status-badge--ai {
  border-color: var(--hs-color-ai-100, #cffafe);
  background: var(--hs-color-ai-50, #ecfeff);
  color: var(--hs-color-ai-700, #0e7490);
}

.status-badge--success {
  border-color: var(--hs-color-success-100, #d1fae5);
  background: var(--hs-color-success-50, #ecfdf5);
  color: var(--hs-color-success-700, #047857);
}

.status-badge--warning {
  border-color: var(--hs-color-warning-100, #fef3c7);
  background: var(--hs-color-warning-50, #fffbeb);
  color: var(--hs-color-warning-700, #b45309);
}

.status-badge--pending {
  border-color: var(--hs-color-pending-100, #ffedd5);
  background: var(--hs-color-pending-50, #fff7ed);
  color: var(--hs-color-pending-700, #c2410c);
}

.status-badge--danger {
  border-color: var(--hs-color-danger-100, #fee2e2);
  background: var(--hs-color-danger-50, #fef2f2);
  color: var(--hs-color-danger-700, #b91c1c);
}

.button {
  display: inline-flex;
  min-width: 72px;
  height: var(--hs-control-md, 36px);
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: var(--hs-radius-md, 6px);
  padding: 0 12px;
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease, box-shadow 120ms ease;
}

.button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--hs-focus-ring, rgba(13, 148, 136, 0.22));
}

.button:disabled {
  cursor: not-allowed;
  background: var(--hs-surface-muted, #eef2f6);
  border-color: var(--hs-border-subtle, #dde3ea);
  color: var(--hs-text-disabled, #94a3b8);
  opacity: 1;
}

.button--sm {
  min-width: 60px;
  height: var(--hs-control-sm, 32px);
  padding: 0 10px;
  font-size: 12px;
}

.button--primary {
  background: var(--hs-btn-primary-bg, #0f766e);
  color: var(--hs-btn-primary-text, #ffffff);
}

.button--primary:hover:not(:disabled) {
  background: var(--hs-btn-primary-bg-hover, #0d9488);
}

.button--secondary {
  border-color: var(--hs-btn-secondary-border, #c7d0da);
  background: var(--hs-btn-secondary-bg, #ffffff);
  color: var(--hs-btn-secondary-text, #334155);
}

.button--secondary:hover:not(:disabled) {
  background: var(--hs-btn-secondary-bg-hover, #f6f8fb);
}

.final-chart-body {
  min-height: 0;
  flex: 1 1 auto;
  overflow: auto;
  padding: 14px;
}

.state-panel {
  display: flex;
  min-height: 180px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--hs-border-subtle, #dde3ea);
  border-radius: 6px;
  background: var(--hs-surface-muted, #eef2f6);
  color: var(--hs-text-muted, #64748b);
  font-size: 13px;
  font-weight: 600;
}

.notice {
  display: grid;
  gap: 4px;
  border: 1px solid transparent;
  border-radius: 6px;
  margin-bottom: 12px;
  padding: 10px 11px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}

.notice strong {
  font-weight: 700;
}

.notice--success {
  border-color: var(--hs-color-success-100, #d1fae5);
  background: var(--hs-color-success-50, #ecfdf5);
  color: var(--hs-color-success-700, #047857);
}

.notice--warning {
  border-color: var(--hs-color-warning-100, #fef3c7);
  background: var(--hs-color-warning-50, #fffbeb);
  color: var(--hs-color-warning-700, #b45309);
  margin-top: 12px;
}

.notice--danger {
  border-color: var(--hs-color-danger-100, #fee2e2);
  background: var(--hs-color-danger-50, #fef2f2);
  color: var(--hs-color-danger-700, #b91c1c);
}

.section-counts {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.section-count {
  border: 1px solid var(--hs-border-subtle, #dde3ea);
  border-radius: 6px;
  background: var(--hs-surface-muted, #eef2f6);
  padding: 9px;
}

.section-count span {
  display: block;
  color: var(--hs-text-muted, #64748b);
  font-size: 12px;
  font-weight: 700;
}

.section-count strong {
  display: block;
  margin-top: 3px;
  color: var(--hs-color-success-700, #047857);
  font-size: 15px;
  font-weight: 800;
}

.section-count strong.is-empty {
  color: var(--hs-color-danger-700, #b91c1c);
}

.gate-panel {
  display: grid;
  gap: 10px;
  margin-top: 12px;
}

.gate-column {
  display: grid;
  gap: 7px;
  border: 1px solid var(--hs-border-subtle, #dde3ea);
  border-radius: 6px;
  background: var(--hs-surface-base, #ffffff);
  padding: 10px;
}

.gate-column--blocking {
  border-color: var(--hs-color-danger-100, #fee2e2);
  background: var(--hs-color-danger-50, #fef2f2);
}

.gate-column--confirmable {
  border-color: var(--hs-color-warning-100, #fef3c7);
  background: var(--hs-color-warning-50, #fffbeb);
}

.gate-column-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.gate-column-head strong {
  color: var(--hs-text-strong, #111827);
  font-size: 13px;
  font-weight: 800;
}

.gate-column-head span {
  color: var(--hs-text-muted, #64748b);
  font-size: 12px;
  font-weight: 700;
}

.gate-item {
  display: grid;
  gap: 3px;
  border: 1px solid var(--hs-border-subtle, #dde3ea);
  border-radius: 6px;
  background: var(--hs-surface-base, #ffffff);
  padding: 8px 9px;
}

.gate-item strong {
  color: var(--hs-text-strong, #111827);
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
}

.gate-item span {
  color: var(--hs-text-muted, #64748b);
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  overflow-wrap: anywhere;
}

.gate-item--blocking {
  border-color: var(--hs-color-danger-100, #fee2e2);
}

.gate-item--confirmable {
  border-color: var(--hs-color-warning-100, #fef3c7);
}

.gate-confirm {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--hs-color-warning-100, #fef3c7);
  border-radius: 6px;
  background: var(--hs-surface-base, #ffffff);
  padding: 8px 9px;
  color: var(--hs-color-warning-700, #b45309);
  font-size: 12px;
  font-weight: 700;
}

.gate-confirm input {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  accent-color: var(--hs-btn-primary-bg, #0f766e);
}

.soap-preview {
  overflow: hidden;
  border: 1px solid var(--hs-border-subtle, #dde3ea);
  border-radius: 6px;
  margin-top: 14px;
  background: var(--hs-surface-base, #ffffff);
}

.correction-panel {
  display: grid;
  gap: 14px;
  padding: 18px;
  border: 1px solid #d8d3c9;
  border-radius: 14px;
  background: #fbfaf7;
}

.correction-panel h3,
.correction-panel p {
  margin: 0;
}

.correction-panel p {
  margin-top: 4px;
  color: #687069;
  font-size: 13px;
}

.correction-panel label {
  display: grid;
  gap: 6px;
  color: #4d554f;
  font-size: 13px;
  font-weight: 700;
}

.correction-panel input,
.correction-panel textarea {
  width: 100%;
  padding: 11px 12px;
  border: 1px solid #cecfc9;
  border-radius: 10px;
  background: #fff;
  color: #283029;
  font: inherit;
  font-weight: 400;
}

.correction-panel textarea {
  resize: vertical;
  line-height: 1.65;
}

.correction-panel footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.soap-preview > div {
  border-bottom: 1px solid var(--hs-border-subtle, #dde3ea);
  padding: 9px 10px;
  color: var(--hs-text-muted, #64748b);
  font-size: 12px;
  font-weight: 700;
}

.soap-preview pre {
  margin: 0;
  padding: 12px;
  color: var(--hs-text-strong, #111827);
  font-family: var(--hs-font-family-base, SUIT), system-ui, sans-serif;
  font-size: 13px;
  line-height: 20px;
  white-space: pre-wrap;
}

@media (max-width: 640px) {
  .final-chart-header {
    align-items: stretch;
    flex-direction: column;
  }
  .final-actions .button {
    flex: 1 1 120px;
  }
  .section-counts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}`],
})
export class PortalHanscribeFinalChartComponent implements OnInit {
    @Input() context: any;
    public componentId = 'final.chart';
    public loading = true;
    public approving = false;
    public error = '';
    public message = '';
    public requestId = '';
    public encounterId = '';
    public draftId = '';
    public review: WorkspaceMap = {};
    public finalGateConfirmed = false;
    public correctionOpen = false;
    public correctionReason = '';
    public correctionText = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.resolveContext();
        await this.loadReview();
    }

    public get busy() {
        return this.loading || this.approving;
    }

    public get finalChartId() {
        return (this.review && this.review.final_chart_id)
            || (this.review && this.review.final_chart && this.review.final_chart.id)
            || '';
    }

    public get readOnlyMode() {
        return !!(this.review && this.review.read_only) || !!this.finalChartId;
    }

    public get finalStatus() {
        if (this.readOnlyMode) return 'approved';
        return (this.review && this.review.status) || 'validation_failed';
    }

    public get blockingItems() {
        const errors = this.asArray(this.review && this.review.errors);
        if (errors.length) return errors;
        return this.asArray(this.review && this.review.blocking_reasons).map((code) => ({ code, message: this.blockerLabel(String(code)) }));
    }

    public get gateBlockingItems() {
        const items = this.asArray(this.review && this.review.blocking_items);
        if (items.length) return items;
        return this.blockingItems.map((item) => ({
            ...item,
            severity: 'blocking',
            category: item.category || 'final_save',
        }));
    }

    public get gateConfirmableItems() {
        return this.asArray(this.review && this.review.confirmable_items);
    }

    public get gateMissingConfirmations() {
        const missing = this.asArray(this.review && this.review.missing_confirmations);
        return missing.length ? missing : this.gateConfirmableItems.filter((item) => item && item.confirmed !== true);
    }

    public get gateNeedsConfirmation() {
        return !this.readOnlyMode && !this.gateBlockingItems.length && this.gateConfirmableItems.length > 0;
    }

    public get gateConfirmationSatisfied() {
        return !this.gateNeedsConfirmation || this.finalGateConfirmed;
    }

    public get canApprove() {
        const serverReady = this.review && (
            this.review.approve_enabled === true
            || (this.review.status === 'confirmation_required' && this.gateBlockingItems.length === 0)
        );
        return !this.busy && !this.readOnlyMode && !!(this.review && this.review.draft_id) && this.gateConfirmationSatisfied && serverReady;
    }

    public get sectionCounts() {
        const counts = this.review && this.review.section_counts ? this.review.section_counts : {};
        return ['S', 'O', 'A', 'P'].map((section) => ({ section, count: Number(counts[section] || 0) }));
    }

    public sectionLabel(section: string) {
        const labels: WorkspaceMap = {
            S: '문진',
            O: '진찰/소견',
            A: '변증/진단',
            P: '치료/처방',
        };
        return labels[section] || '한의 차트';
    }

    public get approvedAt() {
        const chart = this.review && this.review.final_chart ? this.review.final_chart : {};
        return chart.approved_at || '';
    }

    public get soapText() {
        const chart = this.review && this.review.final_chart ? this.review.final_chart : {};
        return chart.soap_text || '';
    }

    public statusLabel(status: string) {
        const labels: WorkspaceMap = {
            approved: '최종 저장',
            already_approved: '최종 저장',
            ready_for_approval: '저장 가능',
            confirmation_required: '확인 후 저장',
            validation_failed: '확인 필요',
            not_found: '없음',
            forbidden: '권한 없음',
        };
        return labels[status] || status || '미정';
    }

    public statusBadgeClass(status: string) {
        return hanscribeStatusBadgeClass(status, 'common', 'status-badge');
    }

    public blockerLabel(code: string) {
        const labels: WorkspaceMap = {
            unsaved_sentences: '미저장 한의 차트 문장이 있습니다.',
            draft_not_found: '저장할 한의 차트가 없습니다.',
            encounter_not_found: '방문 정보를 찾을 수 없습니다.',
            needs_regeneration: '최신 입력 확인이 필요합니다.',
            validation_failed: '한의 차트 확인이 필요합니다.',
            missing_required_sections: '필수 차트 영역이 부족합니다.',
            unreviewed_ai_sentences: '한의사 확인이 필요한 차트 제안이 있습니다.',
            unresolved_red_flags: '진료 전 주의 확인이 필요합니다.',
            required_checklist_unconfirmed: '진료 전 확인이 필요한 항목이 있습니다.',
            precheck_unsubmitted: '예진이 제출되지 않았습니다.',
            nonblocking_red_flag_review: '진료 전 주의 확인이 필요한 항목이 있습니다.',
        };
        return labels[code] || code || '진료 전 확인이 필요합니다.';
    }

    public gateItemTitle(item: WorkspaceMap) {
        if (!item) return '확인 필요';
        if (item.message) return String(item.message);
        return this.blockerLabel(String(item.code || ''));
    }

    public gateItemSummary(item: WorkspaceMap) {
        const rows = this.asArray(item && item.items);
        if (!rows.length) return '';
        return rows.slice(0, 3).map((row) => row.label || row.code || row.status_label || '확인 필요').join(', ')
            + (rows.length > 3 ? ` 외 ${rows.length - 3}건` : '');
    }

    public gateItemClass(item: WorkspaceMap) {
        const severity = item && item.severity === 'blocking' ? 'blocking' : 'confirmable';
        return `gate-item gate-item--${severity}`;
    }

    public async setFinalGateConfirmed(event: any) {
        const checked = event && event.target ? event.target.checked : event;
        this.finalGateConfirmed = checked === true;
        await this.service.render();
    }

    public async loadReview() {
        if (!this.encounterId) {
            this.error = '방문 ID가 없습니다.';
            this.loading = false;
            await this.service.render();
            return;
        }
        this.loading = true;
        this.error = '';
        this.message = '';
        await this.service.render();

        const result = await this.callApi('get_review', {
            encounter_id: this.encounterId,
            draft_id: this.draftId,
        });
        this.loading = false;
        if (result.ok) {
            this.review = result.data && result.data.review ? result.data.review : {};
            this.draftId = this.review.draft_id || this.draftId;
            this.finalGateConfirmed = false;
        } else {
            this.error = result.message;
        }
        await this.service.render();
    }

    public async approve() {
        if (!this.canApprove || this.approving) return;
        if (this.gateNeedsConfirmation && !this.finalGateConfirmed) {
            this.error = '확인 후 진행 가능한 항목을 먼저 확인해주세요.';
            await this.service.render();
            return;
        }
        this.approving = true;
        this.error = '';
        this.message = '';
        await this.service.render();

        const result = await this.callApi('approve', {
            encounter_id: this.encounterId,
            draft_id: this.draftId || this.review.draft_id || '',
            client_dirty: 'false',
            confirmed_gate_codes: this.finalGateConfirmed ? this.gateConfirmableItems.map((item) => item.code || '').filter((code) => code !== '').join(',') : '',
        });
        this.approving = false;
        if (result.ok) {
            const payload = result.data || {};
            const approval = payload.result || {};
            if (payload.context && payload.context.final_chart) {
                this.review = payload.context.final_chart;
            } else {
                this.review = { ...this.review, ...approval };
            }
            this.message = approval.approved ? '최종 차트가 저장되었습니다.' : '';
            if (!approval.approved) this.error = '최종 저장 전 보완 항목을 확인해주세요.';
        } else {
            this.error = result.message;
        }
        await this.service.render();
    }

    public async openCorrection() {
        this.correctionOpen = true;
        this.correctionReason = '';
        this.correctionText = this.soapText;
        this.error = '';
        await this.service.render();
    }

    public async closeCorrection() {
        this.correctionOpen = false;
        await this.service.render();
    }

    public async applyCorrection() {
        if (String(this.correctionReason || '').trim().length < 5) {
            this.error = '정정 사유를 5자 이상 입력해주세요.';
            await this.service.render();
            return;
        }
        if (String(this.correctionText || '').trim() === String(this.soapText || '').trim()) {
            this.error = '변경된 기록 내용이 없습니다.';
            await this.service.render();
            return;
        }
        this.approving = true;
        const result = await this.callApi('correct', {
            final_chart_id: this.finalChartId,
            reason_code: 'clinical_correction',
            reason_text: this.correctionReason,
            soap_text: this.correctionText,
        });
        this.approving = false;
        if (result.ok) {
            const payload = result.data || {};
            if (payload.context?.final_chart) this.review = payload.context.final_chart;
            this.correctionOpen = false;
            this.message = '정정본이 새 버전으로 저장되었습니다.';
        } else {
            this.error = result.message;
        }
        await this.service.render();
    }

    private resolveContext() {
        this.encounterId = this.contextValue('encounter_id') || this.queryValue('encounter_id');
        this.draftId = this.contextValue('draft_id') || this.queryValue('draft_id');
    }

    private contextValue(key: string) {
        if (!this.context || typeof this.context !== 'object') return '';
        if (this.context[key]) return String(this.context[key]);
        if (this.context.encounter && this.context.encounter[key]) return String(this.context.encounter[key]);
        if (this.context.soap && this.context.soap[key]) return String(this.context.soap[key]);
        return '';
    }

    private queryValue(key: string) {
        try {
            const params = new URLSearchParams(window.location.search || '');
            return params.get(key) || '';
        } catch (e) {
            return '';
        }
    }

    private asArray(value: any) {
        if (!value) return [];
        return Array.isArray(value) ? value : [value];
    }

    private async callApi(action: string, payload: any = {}) {
        try {
            const response: any = await wiz.call(action, payload);
            const result = this.unwrapResponse(response);
            this.requestId = result.requestId || this.requestId;
            return result;
        } catch (e) {
            return { ok: false, data: null, requestId: '', message: '요청 처리 중 오류가 발생했습니다.' };
        }
    }

    private unwrapResponse(response: any) {
        const payload = response && response.responseJSON ? response.responseJSON : response;
        const nested = payload && payload.data && payload.data.ok !== undefined ? payload.data : payload;
        const requestId = nested && nested.request_id ? nested.request_id : '';

        if (nested && nested.ok === true) {
            return { ok: true, data: nested.data || {}, requestId, message: '' };
        }
        if (payload && payload.code === 200) {
            return { ok: true, data: payload.data || {}, requestId, message: '' };
        }

        const error = nested && nested.error ? nested.error : null;
        const message = error && error.message ? error.message : '요청을 완료하지 못했습니다.';
        return { ok: false, data: null, requestId, message };
    }
}

export default PortalHanscribeFinalChartComponent;